import { SMSOptType } from "@common/_constants";
import { MessageService, UserService } from "@common/_services";
import { SettingsService } from "@pro/_services";
import { SMSModal } from "@pro/containers/Modals/SMS";
import { PageInternal } from "@pro/containers/PageInternal";
import { Earnings } from "@pro/containers/Pages/Home/Earnings";
import { Messages } from "@pro/containers/Pages/Home/Messages";
import { MyApplications } from "@pro/containers/Pages/Home/MyApplications";
import { MyJobs } from "@pro/containers/Pages/Home/MyJobs";
import { Questions } from "@pro/containers/Pages/Home/Questions";
import { RecommendedJobs } from "@pro/containers/Pages/Home/RecommendedJobs";
import { Referrals } from "@pro/containers/Pages/Home/Referrals";
import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import { AnnouncementBanner } from "./AnnouncementBanner";
import { Role } from "common/models/Role";
import { GlobalConfig } from "common/utils";

interface HomeProps extends RouteComponentProps<any> {}
interface HomeState {
    messageReadStates: any;
    userFirstName: string;
    isSourcer: boolean;
    isLargeScreen: boolean;
    SMSModalIsOpen: boolean;
    isOpen: boolean;
    hasApplications: boolean;
}
export class Home extends Component<HomeProps, HomeState> {
    private _abortControllers: { [key: string]: AbortController } = {};

    constructor(props) {
        super(props);

        const user = UserService.getUserFromStorage();

        const isSourcer = user?.roleId === Role.Sourcer;

        this.state = {
            userFirstName: user ? user.firstName : "",
            isSourcer,
            isLargeScreen: false,
            messageReadStates: {},
            SMSModalIsOpen: false,
            isOpen: false,
            hasApplications: false,
        };

        this.getSMSOptInStatus = this.getSMSOptInStatus.bind(this);
        this.setSMSOptIn = this.setSMSOptIn.bind(this);
        this.onMarkReadStatus = this.onMarkReadStatus.bind(this);
        this.handleApplicationsCounted = this.handleApplicationsCounted.bind(
            this
        );
    }

    componentDidMount() {
        this.setState({
            isLargeScreen: window.matchMedia(
                "(min-width:" + GlobalConfig.ui.breakpoints.md + "px)"
            ).matches,
        });
        window.onresize = () => {
            this.setState({
                isLargeScreen: window.matchMedia(
                    "(min-width:" + GlobalConfig.ui.breakpoints.md + "px)"
                ).matches,
            });
        };
        this.getSMSOptInStatus();
    }

    componentWillUnmount() {
        const abortControllers = this._abortControllers;
        if (Object.keys(abortControllers).length > 0) {
            Object.keys(abortControllers).map(key =>
                abortControllers[key].abort()
            );
        }
    }

    setSMSOptIn() {
        SettingsService.saveSMSOptInStatus(SMSOptType.OptInUnsent).then(
            result => {
                this.setState({ SMSModalIsOpen: false });
            }
        );
    }

    getSMSOptInStatus() {
        // Check to see if there already was an abortController, and if so, call abort on it
        if (this._abortControllers.getSMSOptInStatus) {
            this._abortControllers.getSMSOptInStatus.abort();
        }
        this._abortControllers.getSMSOptInStatus = new AbortController();
        const signal = this._abortControllers.getSMSOptInStatus.signal;

        SettingsService.getSMSOptInStatus(signal).then(result => {
            this.setState({ SMSModalIsOpen: result === SMSOptType.Unknown });
        });
    }

    onMarkReadStatus(messageId, isRead) {
        this.setState(prevState => ({
            messageReadStates: {
                ...prevState.messageReadStates,
                [messageId]: isRead,
            },
        }));

        MessageService.markReadStatus(messageId, isRead);
    }

    handleApplicationsCounted(count: number) {
        this.setState({ hasApplications: count > 0 });
    }

    render() {
        const { hasApplications } = this.state;
        return (
            <PageInternal
                headerTitle="dashboard"
                title={
                    this.state.userFirstName
                        ? "Hi, " + this.state.userFirstName + "!"
                        : "Dashboard"
                }
                gray={true}
                size="lg"
            >
                <div className="c-dashboard">
                    <MyApplications
                        onApplicationsCounted={this.handleApplicationsCounted}
                        show={hasApplications}
                    />
                    <RecommendedJobs show={!hasApplications} />
                    <Earnings />
                    <Questions />
                    <Referrals history={this.props.history} />
                    <Messages
                        messageReadStates={this.state.messageReadStates}
                        onMarkReadStatus={this.onMarkReadStatus}
                    />
                    <MyJobs />
                    <MyApplications show={!hasApplications} />
                    <RecommendedJobs show={hasApplications} />
                </div>
                {this.state.isOpen && (
                    <SMSModal
                        isOpen={this.state.SMSModalIsOpen}
                        onOkay={this.setSMSOptIn}
                        closeModal={this.setSMSOptIn}
                    />
                )}
            </PageInternal>
        );
    }
}
